export const DEPT_COLORS = [
  {
    bg: "bg-blue-100",
    border: "border-blue-300",
    text: "text-blue-700",
    badgeSolid: "bg-blue-500",
    senderText: "text-blue-600",
    statusRead: "text-blue-500",
    checkRead: "text-blue-500",
    bubbleBorder: "border-blue-200",
    editRing: "ring-blue-300",
    btnBg: "bg-blue-500 hover:bg-blue-600",
    arrow: "text-blue-500",
  },
  {
    bg: "bg-green-100",
    border: "border-green-300",
    text: "text-green-700",
    badgeSolid: "bg-green-500",
    senderText: "text-green-600",
    statusRead: "text-green-500",
    checkRead: "text-green-500",
    bubbleBorder: "border-green-200",
    editRing: "ring-green-300",
    btnBg: "bg-green-500 hover:bg-green-600",
    arrow: "text-green-500",
  },
  {
    bg: "bg-purple-100",
    border: "border-purple-300",
    text: "text-purple-700",
    badgeSolid: "bg-purple-500",
    senderText: "text-purple-600",
    statusRead: "text-purple-500",
    checkRead: "text-purple-500",
    bubbleBorder: "border-purple-200",
    editRing: "ring-purple-300",
    btnBg: "bg-purple-500 hover:bg-purple-600",
    arrow: "text-purple-500",
  },
  {
    bg: "bg-orange-100",
    border: "border-orange-300",
    text: "text-orange-700",
    badgeSolid: "bg-orange-500",
    senderText: "text-orange-600",
    statusRead: "text-orange-500",
    checkRead: "text-orange-500",
    bubbleBorder: "border-orange-200",
    editRing: "ring-orange-300",
    btnBg: "bg-orange-500 hover:bg-orange-600",
    arrow: "text-orange-500",
  },
  {
    bg: "bg-pink-100",
    border: "border-pink-300",
    text: "text-pink-700",
    badgeSolid: "bg-pink-500",
    senderText: "text-pink-600",
    statusRead: "text-pink-500",
    checkRead: "text-pink-500",
    bubbleBorder: "border-pink-200",
    editRing: "ring-pink-300",
    btnBg: "bg-pink-500 hover:bg-pink-600",
    arrow: "text-pink-500",
  },
  {
    bg: "bg-amber-100",
    border: "border-amber-300",
    text: "text-amber-700",
    badgeSolid: "bg-amber-500",
    senderText: "text-amber-600",
    statusRead: "text-amber-500",
    checkRead: "text-amber-500",
    bubbleBorder: "border-amber-200",
    editRing: "ring-amber-300",
    btnBg: "bg-amber-500 hover:bg-amber-600",
    arrow: "text-amber-500",
  },
  {
    bg: "bg-cyan-100",
    border: "border-cyan-300",
    text: "text-cyan-700",
    badgeSolid: "bg-cyan-500",
    senderText: "text-cyan-600",
    statusRead: "text-cyan-500",
    checkRead: "text-cyan-500",
    bubbleBorder: "border-cyan-200",
    editRing: "ring-cyan-300",
    btnBg: "bg-cyan-500 hover:bg-cyan-600",
    arrow: "text-cyan-500",
  },
  {
    bg: "bg-lime-100",
    border: "border-lime-300",
    text: "text-lime-700",
    badgeSolid: "bg-lime-500",
    senderText: "text-lime-600",
    statusRead: "text-lime-500",
    checkRead: "text-lime-500",
    bubbleBorder: "border-lime-200",
    editRing: "ring-lime-300",
    btnBg: "bg-lime-500 hover:bg-lime-600",
    arrow: "text-lime-500",
  },
  {
    bg: "bg-indigo-100",
    border: "border-indigo-300",
    text: "text-indigo-700",
    badgeSolid: "bg-indigo-500",
    senderText: "text-indigo-600",
    statusRead: "text-indigo-500",
    checkRead: "text-indigo-500",
    bubbleBorder: "border-indigo-200",
    editRing: "ring-indigo-300",
    btnBg: "bg-indigo-500 hover:bg-indigo-600",
    arrow: "text-indigo-500",
  },
  {
    bg: "bg-rose-100",
    border: "border-rose-300",
    text: "text-rose-700",
    badgeSolid: "bg-rose-500",
    senderText: "text-rose-600",
    statusRead: "text-rose-500",
    checkRead: "text-rose-500",
    bubbleBorder: "border-rose-200",
    editRing: "ring-rose-300",
    btnBg: "bg-rose-500 hover:bg-rose-600",
    arrow: "text-rose-500",
  },
]

export const DEPT_DEFAULT_COLORS = {
  bg: "bg-slate-100",
  border: "border-slate-300",
  text: "text-slate-600",
  badgeSolid: "bg-slate-400",
  senderText: "text-slate-600",
  statusRead: "text-green-500",
  checkRead: "text-green-500",
  bubbleBorder: "border-slate-200",
  editRing: "ring-slate-300",
  btnBg: "bg-slate-500 hover:bg-slate-600",
  arrow: "text-slate-500",
}

export const DEPT_PALETTE_HEX = [
  "#3B82F6",
  "#22C55E",
  "#A855F7",
  "#F97316",
  "#EC4899",
  "#F59E0B",
  "#06B6D4",
  "#84CC16",
  "#6366F1",
  "#F43F5E",
]

export const DEPT_DEFAULT_COLOR_HEX = "#94A3B8"

export const resolveDepartmentColorHex = (dept, index) => {
  if (dept?.color && /^#[0-9A-Fa-f]{6}$/.test(dept.color)) return dept.color
  if (index != null && index >= 0) return DEPT_PALETTE_HEX[index % DEPT_PALETTE_HEX.length]
  return DEPT_DEFAULT_COLOR_HEX
}
